import React, { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import rest from "../../../../common/rest";
import { SURVEY_IDENTIFIER, SURVEY_NAME, SURVEY_VERSION } from "../../../../ducks/survey";
import { createSuccessMessages, messagesReceived } from "../../../../ducks/message";
import ObjectUtils from "../../../../utils/ObjectUtils";
import { cleanText } from "../../../../utils/QuestionUtils";

export default function SaveSectionModal({ section, onHide }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const surveyId = useSelector((state) => state.survey[SURVEY_IDENTIFIER]);
  const surveyName = useSelector((state) => state.survey[SURVEY_NAME]);
  const version = useSelector((state) => state.survey[SURVEY_VERSION]);
  const [snapshot] = useState(() => ({ section: ObjectUtils.deepClone(section), surveyId, surveyName, version }));
  const [name, setName] = useState(() => cleanText(section.title || section.name).slice(0, 255));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const msg = (id) => intl.formatMessage({ id });

  async function save(event) {
    event.preventDefault();
    if (busy || !name.trim()) return;
    setBusy(true);
    setError(false);
    try {
      await rest.doPost("/admin/library/sections/", JSON.stringify({ name: name.trim(), ...snapshot }));
      dispatch(messagesReceived(createSuccessMessages("section.library.saved")));
      onHide();
    } catch (reason) {
      setError(true);
      setBusy(false);
    }
  }

  return (
    <Modal show onHide={() => !busy && onHide()}>
      <Form onSubmit={save}>
        <Modal.Header closeButton={!busy}>
          <Modal.Title>{msg("section.library.save")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{msg("section.library.error")}</Alert>}
          <Form.Group controlId="save-section-library-name">
            <Form.Label>{msg("section.library.name")}</Form.Label>
            <Form.Control
              value={name}
              maxLength={255}
              autoFocus
              disabled={busy}
              onChange={(event) => setName(event.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" disabled={busy} onClick={onHide}>
            {msg("app.common.Cancel")}
          </Button>
          <Button type="submit" disabled={busy || !name.trim()}>
            {msg("survey.editor.save")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
